<template>
    <form class="kt-form" @submit.prevent="update">
        <kt-form-section is_first>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="username">
                            {{ $t('label.username') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="username" id="username" v-model="user.username"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t('label.email') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="email" id="email" v-model="user.email"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="first_name">
                            {{ $t('label.first_name') }}
                        </kt-form-label>
                        <kt-form-control name="first_name" id="first_name" v-model="user.first_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="first_name_en">
                            {{ $t('label.first_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="first_name_en" id="first_name_en" v-model="user.first_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="last_name">
                            {{ $t('label.last_name') }}
                        </kt-form-label>
                        <kt-form-control name="last_name" id="last_name" v-model="user.last_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="last_name_en">
                            {{ $t('label.last_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="last_name_en" id="last_name_en" v-model="user.last_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="father_name">
                            {{ $t('label.father_name') }}
                        </kt-form-label>
                        <kt-form-control name="father_name" id="father_name" v-model="user.father_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="father_name_en">
                            {{ $t('label.father_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="father_name_en" id="father_name_en" v-model="user.father_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>

            <kt-form-row>
                <kt-col>
                    <kt-form-group>
                        <kt-form-label for="birth_date">
                            {{ $t('label.birth_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="birth_date"
                                name= "birth_date"
                                v-model="user.birth_date"
                                type="date" />
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>

        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="phone">
                            {{ $t('label.phone') }}
                        </kt-form-label>
                        <kt-input-group class="">
                            <kt-form-control dir="ltr" name="phone" id="phone" v-model="user.phone"></kt-form-control>
                            <kt-input-group-append>
                            <kt-input-group-text>
                                <a  target="_blank" :href="'https://wa.me/' + getUserPhone(user.phone)">
                                    <img class="wa-img" src="https://img.icons8.com/officexs/16/000000/whatsapp.png">
                                </a>
                            </kt-input-group-text>
                            </kt-input-group-append>
                        </kt-input-group>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control ref="telephone" dir="ltr" name="telephone" id="telephone" v-model="user.telephone"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>

        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="national_code">
                            {{ $t('label.national_code') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" maxlength="10" name="national_code" id="national_code" v-model="user.national_code"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                {{ $t('btn.submit_changes') }}
            </button>
        </kt-form-action>
    </form>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { userService } from '@/common/api.service'
import Inputmask from "inputmask";
import {i18n} from "@/plugins/i18n";

export default {
    computed: {
        ...mapGetters('user', [
            'user'
        ])
    },
    data() {
        return {
            months: [
                {
                    title: i18n.t('month.farvardin'),
                    value: 1
                },
                {
                    title: i18n.t('month.ordibehesht'),
                    value: 2
                },
                {
                    title: i18n.t('month.khordad'),
                    value: 3
                },
                {
                    title: i18n.t('month.tir'),
                    value: 4
                },
                {
                    title: i18n.t('month.mordad'),
                    value: 5
                },
                {
                    title: i18n.t('month.shahrivar'),
                    value: 6
                },
                {
                    title: i18n.t('month.mehr'),
                    value: 7
                },
                {
                    title: i18n.t('month.aban'),
                    value: 8
                },
                {
                    title: i18n.t('month.azar'),
                    value: 9
                },
                {
                    title: i18n.t('month.day'),
                    value: 10
                },
                {
                    title: i18n.t('month.bahman'),
                    value: 11
                },
                {
                    title: i18n.t('month.esfand'),
                    value: 12
                },
            ],
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.initialSetup()
        })
    },
    methods: {
        getUserPhone(phone) {
            if (phone)
                return '98' + phone.substr(-10, 10)
        },
        initialSetup() {
            setTimeout(() => {
                if(!this.$refs.selectPicker) {
                    return
                }
                let selects = $(this.$refs.selectPicker.$el).find('.kt-selectpicker')
                $(selects).selectpicker({
                    size: 5
                })

                Inputmask('099-99999999').mask(this.$refs.telephone.$el)
            }, 1000)

        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    username: {
                        required: true,
                        minlength: 5
                    },
                    first_name: {
                        required: true,
                    },
                    last_name: {
                        required: true,
                    },
                    first_name_en: {
                        required: true,
                    },
                    last_name_en: {
                        required: true,
                    },
                    father_name: {
                        required: true,
                    },
                    father_name_en: {
                        required: true,
                    },
                    national_code: {
                        required: true,
                    },
                    birth_date: {
                        required: true,
                    },
                    telephone: {
                        required: true
                    },
                    phone: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                },
            });

            if(!form.valid()) {
                return
            }

            if (!this.validateSocialId(this.user.national_code)) {
                form.validate().showErrors({
                    national_code: i18n.t('validation.invalid_national_code')
                })
                return;
            }

            let params = {
                username: this.user.username,
                first_name: this.user.first_name,
                first_name_en: this.user.first_name_en,
                last_name: this.user.last_name,
                last_name_en: this.user.last_name_en,
                father_name: this.user.father_name,
                father_name_en: this.user.father_name_en,
                national_code: this.user.national_code,
                birth_date: this.user.birth_date,
                telephone: this.user.telephone,
                phone: this.user.phone,
                email: this.user.email,
            }

            KTApp.progress(btn)

            userService.updateUser(this.user.id, params)
                .then(response => {
                    this.$store.commit('user/success', response.data.data)
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                        this.showMsg(form, 'danger', response.data.message)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
        getYear() {
            return new Date().getFullYear() - 721
        },
        validateSocialId(social_id) {
            var L=social_id.length;

            if(L<8 || parseInt(social_id,10)==0) return false;
            social_id=('0000'+social_id).substr(L+4-10);
            if(parseInt(social_id.substr(3,6),10)==0) return false;
            var c=parseInt(social_id.substr(9,1),10);
            var s=0;
            for(var i=0;i<9;i++)
                s+=parseInt(social_id.substr(i,1),10)*(10-i);
            s=s%11;
            return (s<2 && c==s) || (s>=2 && c==(11-s));
        },
    }
}
</script>

<style>

</style>